document.addEventListener("DOMContentLoaded", function () {
  const title = document.querySelector(".jdgm-rev-widg__title");
  const wrapper = document.querySelector(".jdgm-row-stars");
 console.log("fjdghfk");
  if (!title || !wrapper) return;

  // Create SVG toggle icon (e.g., down arrow)
  const svgToggle = document.createElement("span");
  svgToggle.innerHTML = `
    <svg id="toggle-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16" style="cursor:pointer; margin-left: 8px;">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `;
  title.appendChild(svgToggle);

  let isOpen = true;

  svgToggle.addEventListener("click", () => {
    isOpen = !isOpen;
    wrapper.style.display = isOpen ? "block" : "none";

    const svg = svgToggle.querySelector("svg");
    svg.innerHTML = isOpen
      ? `<path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>` // Down arrow
      : `<path fill-rule="evenodd" d="M1.646 11.354a.5.5 0 0 0 .708 0L8 5.707l5.646 5.647a.5.5 0 0 0 .708-.708l-6-6a.5.5 0 0 0-.708 0l-6 6a.5.5 0 0 0 0 .708z"/>`; // Up arrow
  });
});
